import { createSlice } from "@reduxjs/toolkit";
var initialState = { user: undefined };
/** Залогиненного пользователя храним без хуков */
export var profileSlice = createSlice({
    name: "authUser",
    initialState: initialState,
    reducers: {
        setAuthUser: function (state, action) {
            state.user = action.payload;
        },
    },
});
export var setAuthUser = profileSlice.actions.setAuthUser;
var profileReducer = profileSlice.reducer;
export default profileReducer;
